import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://www.api.toskyapps.com',
  withCredentials: true,
});

export { api };